function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.25 3C10.25 4.24375 9.24375 5.25 8 5.25C6.75625 5.25 5.75 4.24375 5.75 3C5.75 1.75625 6.75625 0.75 8 0.75C9.24375 0.75 10.25 1.75625 10.25 3ZM13.5 0.75C12.2563 0.75 11.25 1.75625 11.25 3C11.25 4.24375 12.2563 5.25 13.5 5.25C14.7437 5.25 15.75 4.24375 15.75 3C15.75 1.75625 14.7437 0.75 13.5 0.75ZM2.5 0.75C1.25625 0.75 0.25 1.75625 0.25 3C0.25 4.24375 1.25625 5.25 2.5 5.25C3.74375 5.25 4.75 4.24375 4.75 3C4.75 1.75625 3.74375 0.75 2.5 0.75Z",
  fill: "black"
});

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.5fd9a767.svg";
export { ForwardRef as ReactComponent };